const minTemp = "Compare Temperature Minimum";
const maxTemp = "Compare Temperature Maximum";
const maxVoltageAc = "Compare Voltage DC";

export const filmLifetimeExtremes = {
    minTemp,
    maxTemp,
    maxVoltageAc
};